// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"db3b36af","539":"5d52e546","618":"3e97dee1","744":"c4b5adfa","790":"9de66361","879":"b8bbc7d9","951":"c7c9212e"}[chunkId] + ".chunk.js";
};